import { useCallback, useState } from "react";
import { useMutation } from "@apollo/client";
import { PUBLISH_MEASURE_MUTATION, TRANSITION_MEASURE_MUTATION } from "../api/mutations";

function toGqlStatus(status: string): string {
  return status.trim().toUpperCase();
}

export function useMeasureLifecycle(onDone?: () => void) {
  const [busyId, setBusyId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [publishMut] = useMutation(PUBLISH_MEASURE_MUTATION);
  const [transitionMut] = useMutation(TRANSITION_MEASURE_MUTATION);

  const publish = useCallback(
    async (mesureId: string, fromStatus: string) => {
      setBusyId(mesureId);
      setError(null);
      try {
        await publishMut({
          variables: {
            input: {
              mesureId,
              expectedFromStatus: toGqlStatus(fromStatus),
              justification: "Publication manager depuis le catalogue Mesures",
              occurredAt: new Date().toISOString(),
            },
          },
        });
        onDone?.();
      } catch (e) {
        setError(e instanceof Error ? e.message : "Publication impossible");
      } finally {
        setBusyId(null);
      }
    },
    [onDone, publishMut],
  );

  const scientificValidate = useCallback(
    async (mesureId: string, fromStatus: string) => {
      setBusyId(mesureId);
      setError(null);
      try {
        await transitionMut({
          variables: {
            input: {
              mesureId,
              toStatus: "VALIDEE",
              expectedFromStatus: toGqlStatus(fromStatus),
              justification: "Validation scientifique depuis le catalogue Mesures",
              occurredAt: new Date().toISOString(),
            },
          },
        });
        onDone?.();
      } catch (e) {
        setError(e instanceof Error ? e.message : "Validation impossible");
      } finally {
        setBusyId(null);
      }
    },
    [onDone, transitionMut],
  );

  return { publish, scientificValidate, busyId, error, clearError: () => setError(null) };
}
